<template>
  <div class="mt-4">
    <div v-if="!add" class="d-flex">
      <div :style="renewTableStyles" class="smooth">
        <v-card class="mt-8 mx-auto ml-5 mr-5">
          <v-card-title class="tableheader">
            Manage My Packs
            <div class="flex-grow-1"></div>
            <v-text-field
              class="search"
              v-model="searchMyPack"
              append-icon="search"
              label="Search"
              color="white"
              hide-details
            >
            </v-text-field>
          </v-card-title>
          <v-data-table
            class="my-packs-table"
            disable-pagination
            :show-select="isDP != true"
            v-model="selectedCurrent"
            :headers="headers"
            :items="packs"
            item-key="uid"
            @click:row="myPackClick"
            :search="searchMyPack"
          ></v-data-table>
          <Button
            cssClass="ml-3 mb-3"
            color="primary"
            label="Modify Packs"
            @click="() => $router.push('/manage/add')"
          />
        </v-card>
      </div>
      <Summary
        v-if="isDP != true"
        :loading="loading"
        title="Modify Packs Checkout"
        :styles="renewSummaryStyles"
        :selectedPacks="renewPacks"
        buttonText="Proceed To Pay"
        @click="renewPlan"
        :subscriptionAmount="renewTotal"
        :ncfAmount="renewNCF"
      />
    </div>
    <div v-else class="d-flex">
      <div :style="tableStyles" class="smooth">
        <v-card max-width="90%" class="mt-8 mx-auto">
          <v-card-text :style="{ paddingTop: '0 !important' }">
            <div class="d-flex tableheader pr-5 py-2">
              <v-tabs v-model="packType" class="pack_type_tabs" color="white">
                <v-tab key="base" color="white">Base Packs</v-tab>
                <v-tab key="indigital.index">Tisai Packs</v-tab>
                <v-tab key="broadcaster">Broadcaster Packs</v-tab>
                <v-tab key="ala">A-la-carte</v-tab>
              </v-tabs>
              <div class="flex-grow-1"></div>
              <v-text-field
                class="search"
                v-model="searchAddPack"
                append-icon="search"
                label="Search"
                color="white"
                hide-details
              />
            </div>
            <v-data-table
              :loading="loading"
              v-model="selectedNewPack"
              :items="modalItems"
              :headers="packColumns"
              item-key="id"
              show-select
              :single-select="false"
              :search="searchAddPack"
              @click:row="addPackClick"
            />
          </v-card-text>
        </v-card>
      </div>
      <div
        :style="summaryStyles"
        class="smooth"
        v-if="selectedNewPack && selectedNewPack.length > 0"
      >
        <v-card class="mt-8 mr-8">
          <v-card-title class="tableheader py-4">Renew Checkout</v-card-title>
          <v-card-text>
            <div>
              <h5 class="ml-2 mt-2" style="color: #afafaf"><b>Summary</b></h5>
            </div>
            <div v-for="(pack, idx) in selectedNewPack" :key="idx">
              <v-divider style="margin: 0" />
              <div class="summary-pack d-flex">
                <div class="name">
                  <div>{{ pack.planName }}</div>
                  <div class="channel">{{ pack.channelCount }} Channels</div>
                </div>
                <div class="price">
                  <span class="rupee-big">&#8377;</span>
                  {{
                    $toFixed((parseFloat(pack.tariff) + pack.ncfPrice) * 1.18)
                  }}

                  <span class="raw"> /month</span>
                </div>
              </div>
            </div>
            <v-divider style="margin-top: 0" />
            <div class="summary_item">
              <div class="head">Subscription Amount</div>
              <div class="value">
                <span class="rupee">&#8377;</span>{{ subscriptionAmount }}
              </div>
            </div>
            <div class="summary_item">
              <div class="head">NCF Amount</div>
              <div class="value">
                <span class="rupee">&#8377;</span>{{ ncfAmount }}
              </div>
            </div>
            <div class="summary_item">
              <div class="head">GST</div>
              <div class="value">
                <span class="rupee">&#8377;</span>
                {{
                  $toFixed(
                    (parseFloat(subscriptionAmount) + ncfAmount) * 0.18,
                    2
                  )
                }}
              </div>
            </div>
            <v-divider />
            <div class="summary_item">
              <div class="head">Total Amount</div>
              <span class="rupee">&#8377;</span>
              <div class="value">{{ addTotal }}</div>
            </div>
          </v-card-text>
          <v-card-actions class="actions">
            <Button
              cssClass="mr-3 mb-3"
              color="primary"
              label="Proceed to Pay"
              v-if="!loading"
              @click="addPlan"
            />
            <v-progress-circular v-else indeterminate />
          </v-card-actions>
        </v-card>
      </div>
    </div>
    <v-dialog
      v-model="showChannels"
      transition="dialog-bottom-transition"
      class="wrap"
      scrollable
      overlay-opacity="0.9"
    >
      <channel-list
        :channels="channels"
        :planName="openedPlan.planName"
        @close="showChannels = false"
      />
    </v-dialog>
    <v-snackbar v-model="showMessage" :color="color">
      {{ message }}
      <v-btn dark text>Close</v-btn>
    </v-snackbar>
  </div>
</template>
<style lang="sass" scoped>
.name
  width: 150px
.actions
  flex-direction: row-reverse
.pack_type_tabs
  max-width: 720px
.search
  max-width: 200px
  position: relative
  top: -7px
.summary_item
  display: flex
  .head
    flex: 1
    text-align: right
    padding: 0 10px
    font-weight: 700
  .value
    width: 70px
    margin-right: 20px
    padding: 0 10px 0 10px
    position: relative
  .rupee
    position: relative
    right: 0
.v-card__text
  padding-left: 0
  padding-right: 0
.smooth
  transition: width 0.2s ease
.summary-pack
  padding: 10px 0
  .name
    padding-left: 10px
    font-weight: 700
    color: #333
    flex-grow: 1
    .channel
      font-weight: 500
      color: #777
  .price
    padding-right: 10px
    font-size: 20px
    font-weight: 700
    padding-top: 10px
    .raw
      font-size: 14px
      font-weight: 400
</style>

<script>
import { extractError } from "../../utils/error";
import Button from "../../components/Elements/Button";
import Summary from "./Summary.vue";
import ChannelList from "../../components/Channel/List";
import config from "./config";
import {
  getBasePlansByRegion,
  getIndigitalPlansByRegion,
  getAlaCarteByRegion,
  getBroadcasterPlansByRegion,
  addPlan as addPlanService,
  renewPlan as renewPlanService,
} from "../../services/pack";

import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    Button,
    Summary,
    ChannelList,
  },
  data() {
    return {
      showChannels: false,
      openedPlan: {
        planName: "",
      },
      channels: [],
      loading: false,
      currentTab: 0,
      message: "",
      showMessage: false,
      color: "",
      showInfo: false,
      selectedCurrent: [],
      packType: 1,
      addModal: false,
      selectedNewPack: [],
      alaCartePacks: [],
      indigitalPacks: [],
      broadcasterPacks: [],
      basePacks: [],
      searchAddPack: "",
      searchMyPack: "",
      headers: config.headers,
      packColumns: config.packColumns,
      renewStatus: -1,
    };
  },
  props: {
    add: Boolean,
  },
  methods: {
    async setupData() {
      try {
        this.getUserInfo();
        console.info("setupdata: making loading true");
        this.loading = true;
        const { isBase, isIndigital, isBroadcaster } = this;
        const dp = this.isDP == true ? 0 : 1;
        const region = this.regionCode;

        const itemsPath = isBase
          ? "basePacks"
          : isIndigital
          ? "indigitalPacks"
          : isBroadcaster
          ? "broadcasterPacks"
          : "alaCartePacks";

        const remoteService = isBase
          ? getBasePlansByRegion
          : isIndigital
          ? getIndigitalPlansByRegion
          : isBroadcaster
          ? getBroadcasterPlansByRegion
          : getAlaCarteByRegion;

        const items = this[itemsPath];

        if (items && items.length > 0) {
          // console.log('already fetched : ', items);
          this.loading = false;
          return;
        }

        const result = await remoteService(region, dp);
        console.error("making loading false");
        this.loading = false;
        // console.log('setup pages result : ', result);

        const {
          response: { result: content },
        } = result;

        this[itemsPath] = content.map((p) => ({
          ...p,
          id: p.identity.planCode + ":" + p.identity.region,
          finalPrice: this.$toFixed(
            this.calculateGST(parseFloat(p.tariff) + p.ncfPrice),
            2
          ),
        }));
      } catch (err) {
        console.log("setupdata: err: ", err);
        console.log("making loading false");
        this.loading = false;
        const message = extractError(err);
        this.$showError(message);
      }
    },
    calculateGST(price, rate = 18) {
      const gstRaw = price * (rate / 100);
      const gstRounded = Math.round(gstRaw * 100) / 100; // Rounds to 2 decimalsreturn gstRounded;
      return price + gstRounded;
    },
    processError(message) {
      if (Array.isArray(message) && message.length > 0) {
        message.forEach((msg) => {
          this.displayMessage(msg, "error");
        });
      } else if (message && message.length > 0) {
        this.displayMessage(message, "error");
      } else {
        this.displayMessage("Something went wrong", "error");
      }
    },
    async addPlan() {
      try {
        this.loading = true;
        const payload = this.selectedNewPack;
        const result = await addPlanService(this.accountNo, payload);
        const {
          response: { result: statuses },
        } = result;
        let newSelected = payload.slice();
        statuses.forEach(({ status, plan_code, plan_name }) => {
          // console.log('status is : ', status);
          if (status === "SUCCESS") {
            this.$toasted.success(plan_name + " is added", {
              duration: 2000,
            });
            const idx = payload.findIndex(
              (p) => p.identity.planCode === plan_code
            );
            if (idx >= 0) {
              newSelected[idx] = null;
            }
          } else {
            this.$toasted.error(plan_name + " could not be added", {
              duration: 2000,
            });
          }
        });
        newSelected = newSelected.filter((p) => p !== null);
        this.selectedNewPack = newSelected;
        this.loading = false;
        if (!(newSelected.length > 0))
          this.displayMessage("Plans Subscribed Successfully", "success");
        this.setupData();
      } catch (err) {
        console.log(err);
        this.loading = false;
        const message = extractError(err);
        this.processError(message);
      }
    },
    async renewPlan() {
      try {
        this.loading = true;
        const payload = this.selectedCurrent;
        // console.log('payload : ', payload, 'loading : ', this.loading);
        const statuses = await renewPlanService(this.accountNo, payload);
        // console.log('got result statuses : ', statuses);
        let newSelected = payload.slice();
        statuses.forEach(({ plan_code, status }) => {
          if (status === "SUCCESS") {
            const index = payload.findIndex((p) => p.plan_CODE === plan_code);
            // console.log('got index : ', index);
            newSelected[index] = null;
          }
        });
        newSelected = newSelected.filter((p) => p !== null);
        // console.log('length is : ', newSelected.length);
        if (newSelected.length !== 0) {
          this.renewStatus = 0;
          this.displayMessage("Could not renew some plans", "error");
        } else {
          this.renewStatus = 1;
          this.displayMessage("Plans Renewed Successfully", "success");
        }
        this.setupData();
        this.selectedCurrent = newSelected;
        // console.log('final new selected : ', newSelected);
        this.loading = false;
        // this.selectedCurrent = [];
      } catch (err) {
        this.loading = false;
        console.log(err);
        const message = extractError(err);
        this.processError(message);
        // this.displayMessage('Something went wrong', 'error');
      }
    },
    myPackClick(row) {
      const {
        planMaster: { channelMasters },
      } = row;
      if (Array.isArray(channelMasters) && channelMasters.length > 0) {
        this.showChannels = true;
        this.channels = channelMasters;
        this.openedPlan = row.planMaster;
      }
    },
    addPackClick(row) {
      const { channelMasters } = row;
      if (Array.isArray(channelMasters) && channelMasters.length > 0) {
        this.showChannels = true;
        this.channels = channelMasters;
        this.openedPlan = row;
      }
    },
    displayMessage(msg, color) {
      this.message = msg;
      this.color = color;
      this.showMessage = true;
    },
    makeTableStyles(path) {
      const packsSelected = this[path] && this[path].length > 0;
      if (packsSelected) {
        return {
          width: "70%",
        };
      }
      return {
        width: "100%",
      };
    },
    makeSummaryStyles(path) {
      const packsSelected = this[path] && this[path].length > 0;
      if (!packsSelected) {
        return {
          width: "0px",
          display: "none",
        };
      }
      return {
        width: "30%",
      };
    },
    ...mapActions("auth", ["getUserInfo"]),
  },
  computed: {
    ...mapState("auth", {
      packs: (state) => {
        if (!state.profile.plans) {
          return [];
        }
        const plans = state.profile.plans.map((p) => ({
          ...p,
          uid:
            p.planMaster.identity.planCode + ":" + p.planMaster.identity.region,
          finalPrice: parseFloat(
            (parseFloat(p.planMaster.tariff) + p.planMaster.ncfPrice) * 1.18
          ).toFixed(2),
        }));
        const typeWeightage = {
          BST: 4,
          INT: 3,
          BQ: 2,
          ALC: 1,
        };
        if (Array.isArray(plans)) {
          plans.sort((a, b) => {
            const aCategory = a.planMaster.category;
            const bCategory = b.planMaster.category;
            // console.log('a : ', aCategory, ' b : ', bCategory, '\nand : ', typeWeightage[aCategory] > typeWeightage[bCategory]);
            return typeWeightage[aCategory] > typeWeightage[bCategory] ? -1 : 1;
          });
        }
        return plans;
      },
      region: (state) => state.profile.region,
      accountNo: (state) => state.accountNo,
    }),
    ...mapGetters("auth", ["isDP", "regionCode"]),
    packSet() {
      return new Set(this.packs.map((p) => p.uid));
    },
    isBase() {
      return this.packType == 0;
    },
    isIndigital() {
      return this.packType == 1;
    },
    isBroadcaster() {
      return this.packType == 2;
    },
    modalItems() {
      let items =
        this.packType == 3
          ? this.alaCartePacks
          : this.packType == 1
          ? this.indigitalPacks
          : this.packType == 2
          ? this.broadcasterPacks
          : this.basePacks;
      // console.log('intermediate items : ', items);
      if (this.packSet.size > 0) {
        items = items.filter((i) => !this.packSet.has(i.id));
      }
      return items;
    },
    subscriptionAmount() {
      const packs = this.selectedNewPack || [];
      const val = packs.reduce((acc, i) => acc + parseFloat(i.tariff), 0);
      return this.$toFixed(val, 2);
    },
    ncfAmount() {
      const packs = this.selectedNewPack || [];
      return packs.reduce((acc, i) => acc + parseFloat(i.ncfPrice), 0);
    },
    addTotal() {
      return this.$toFixed(
        (parseFloat(this.subscriptionAmount) + this.ncfAmount) * 1.18,
        2
      );
    },
    renewTotal() {
      const packs = this.selectedCurrent || [];
      return packs.reduce((acc, i) => acc + parseFloat(i.planMaster.tariff), 0);
    },
    renewNCF() {
      const packs = this.selectedCurrent || [];
      return packs.reduce(
        (acc, i) => acc + parseFloat(i.planMaster.ncfPrice),
        0
      );
    },
    tableStyles() {
      const packsSelected =
        this.selectedNewPack && this.selectedNewPack.length > 0;
      if (packsSelected) {
        return {
          width: "70%",
        };
      }
      return {
        width: "100%",
      };
    },
    renewTableStyles() {
      return this.makeTableStyles("selectedCurrent");
    },
    renewSummaryStyles() {
      return this.makeSummaryStyles("selectedCurrent");
    },
    renewPacks() {
      const packs = this.selectedCurrent || [];
      return packs.map((p) => ({
        original: p,
        ...p.planMaster,
      }));
    },
    summaryStyles() {
      const packsSelected =
        this.selectedNewPack && this.selectedNewPack.length > 0;
      if (!packsSelected) {
        return {
          width: "1px",
        };
      }
      return {
        width: "30%",
      };
    },
  },
  watch: {
    packType: function (val) {
      console.log("watcher called : ", val);
      this.searchAddPack = "";
      this.setupData();
    },
    packs: function () {
      if (this.renewStatus === 0) {
        this.renewStatus = -1;
      } else {
        this.selectedCurrent = this.packs.slice();
      }
    },
  },
  async mounted() {
    this.selectedCurrent = this.packs.slice();
    if (!this.regionCode) {
      console.log("region code timeout");
      setTimeout(this.setupData, 1000);
    } else {
      this.setupData();
    }
  },
};
</script>
<style>
.v-tab {
  color: rgb(255, 255, 255) !important;
}
.v-tab--active {
  color: rgb(0, 0, 0) !important;
  font-weight: bolder !important;
}
.v-slide-group {
  background-color: transparent !important;
}
.search label {
  color: #ccc !important;
}
.search .v-icon,
.search .v-input__slot::before {
  color: #ccc !important;
}
.search input {
  color: #fff !important;
}
.v-tabs-slider {
  background-color: rgb(0, 0, 0) !important;
}
.tableheader {
  background-image: linear-gradient(
    159.6deg,
    rgb(140, 177, 207) 11.2%,
    rgb(54, 129, 167) 100.2%
  );
  color: white;
}
.theme--light.v-data-table thead tr th {
  color: black !important;
  font-size: 16px;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
